import React, { useState, useEffect } from "react";

const WhoWeServe = () => {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || "en");
    };
    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const content = {
    en: {
      heading: "WHO WE SERVE",
      subHeading: "For those who value getting it right.",
      description:
        "We work with individuals who have built something worth protecting, business owners who need coverage as thoughtful as their enterprise, and corporates who expect more than a standard policy. If you take your financial future seriously, we will too.",
    },
    zh: {
      heading: "我们的服务对象",
      subHeading: "致那些重视正确选择的人。",
      description:
        "我们与建立过值得保护的事业的个人、需要像其企业一样周全保障的企业主以及期望获得超出标准保单的服务的大型公司合作。如果您认真对待您的财务未来，我们也会如此。",
    },
  };

  const current = content[lang];

  return (
   <section className="relative pb-12 md:pb-12 bg-white">

  <div className="relative max-w-3xl mx-auto px-6 text-center">

    {/* SMALL HEADING */}
    <span className="text-[#B08D57] uppercase tracking-[0.35em] text-[11px] mb-5 block font-sans">
      {current.heading}
    </span>

    {/* MAIN HEADING */}
    <h2 className="mb-6 text-[28px] md:text-[36px] leading-tight font-serif text-[#1A1A1A]">
      {current.subHeading}
    </h2>

    {/* DESCRIPTION */}
    <p className="text-[14px] md:text-[16px] leading-relaxed text-[#999999] max-w-2xl mx-auto">
      {current.description}
    </p>

   
  </div>

</section>
  );
};

export default WhoWeServe;